import { Collaborator } from "@domain/project/collaborator";
import { ReadAccess } from "@domain/project/read-access";
import { BusinessScope } from "@lib/constants/business-scope";
import { Type } from "class-transformer";
import { IsArray, IsDate, IsEnum, IsNumber, IsOptional, IsString } from "class-validator";

export class CloudProjectMetadata {
  @IsString()
  public id: string;

  @IsString()
  users: Collaborator[];

  @IsString()
  public displayName: string;

  @IsString()
  customerName: string;

  @IsString()
  public lastModifiedOn: string;

  @IsString()
  projectHash: string;

  @IsString()
  updatedBy: string;

  @IsEnum(BusinessScope)
  businessScope: BusinessScope;

  @IsString()
  @IsOptional()
  name?: string;

  @IsDate()
  @Type(() => Date)
  @IsOptional()
  updatedAt?: Date;

  @IsNumber()
  totalFileSize: number = 0;

  @IsArray()
  readAccesses: ReadAccess[] = [];

  @IsString()
  status: string;

  @IsString()
  localProjectId: string;

  @IsString()
  @IsOptional()
  institutionId?: string;

  @IsString()
  @IsOptional()
  institutionType?: string;

  constructor(
    id: string,
    displayName: string,
    customerName: string,
    lastModifiedOn: string,
    users: Collaborator[],
    projectHash: string,
    updatedBy: string,
    status: string,
    localProjectId: string,
    businessScope: BusinessScope,
    name?: string,
    updatedAt?: Date,
    institutionId?: string,
    institutionType?: string,
  ) {
    this.id = id;
    this.displayName = displayName;
    this.customerName = customerName;
    this.lastModifiedOn = lastModifiedOn;
    this.users = users;
    this.projectHash = projectHash;
    this.updatedBy = updatedBy;
    this.status = status;
    this.localProjectId = localProjectId;
    this.name = name;
    this.updatedAt = updatedAt;
    this.businessScope = businessScope;
    this.institutionId = institutionId;
    this.institutionType = institutionType;
  }
}
